import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { get, find } from 'lodash';
import { withRouter } from 'react-router-dom';
import { categories } from '../categories/_api';
import { withStyles } from '@material-ui/core/styles';
import withLoader from '../../modules/app/withLoader';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import {
  Grid,
  Table,
  TableHeaderRow,
  TableFilterRow,
  TableColumnReordering,
  DragDropProvider,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import {
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  PagingState,
} from '@devexpress/dx-react-grid';
import Paper from '@material-ui/core/Paper';
import { getCategory } from '../categories/_api';
import { updateCategoryConfig } from '../items/_api';
import { listProducts } from './_api';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { setActiveCategory } from '../app/_api';
import { without } from 'lodash';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
});

const enhance = compose(
  withStyles(styles),
  withState('categories', 'setCategories', []),
  withState('category', 'setCategory', []),
  withState('columnOrder', 'setColumnOrder', []),
  withState('products', 'setProducts', []),
  withRouter,
  withLoader,
  connect((state) => ({ activeCategory: get(state, 'app.activeCategory', 'BEZKY') }), {
    setActiveCategory,
  }),
  withHandlers({
    loadItems: ({ setProducts }) => async (id) => {
      const resp = await listProducts(id);
      if (resp) {
        setProducts(resp.items);
      }
    },
    loadCategoryAndOrder: ({ setCategory, setColumnOrder }) => async (categoryId) => {
      const cat = await getCategory(categoryId);
      setCategory(cat);
      const colOrder = get(cat, 'config.attributesOrder', []);
      if (colOrder.length === get(cat, 'attributes', []).length) {
        setColumnOrder(
          without([...colOrder.map((item) => `${get(item, 'id', null)}`), 'delete'], 'null')
        );
      } else {
        setColumnOrder(
          without(
            [...get(cat, 'attributes', []).map((item) => `${get(item, 'id', null)}`), 'delete'],
            'null'
          )
        );
      }
    },
  }),
  lifecycle({
    async componentDidMount() {
      const {
        setCategories,
        toggleLoader,
        loadItems,
        activeCategory,
        loadCategoryAndOrder,
      } = this.props;
      toggleLoader();
      const resp = await categories();
      if (resp) {
        setCategories(resp.items);
        await loadCategoryAndOrder(activeCategory);
        await loadItems(activeCategory);
      }
      toggleLoader(false);
    },
    async componentWillReceiveProps(nextProps) {
      const { loadItems, toggleLoader, category } = this.props;
      if (this.props.reload !== nextProps.reload) {
        toggleLoader();
        await loadItems(category.id);
        toggleLoader(false);
      }
    },
  }),
  withHandlers({
    redirectTo: ({ history }) => async (id) => {
      history.push(`/products/${id}`);
    },
  }),
  withHandlers({
    TabContainer: () => (props) => {
      return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
          {props.children}
        </Typography>
      );
    },
    handleTabChange: ({
      toggleLoader,
      setActiveCategory,
      loadCategoryAndOrder,
      loadItems,
    }) => async (event, categoryId) => {
      toggleLoader();
      setActiveCategory(categoryId);
      await loadCategoryAndOrder(categoryId);
      await loadItems(categoryId);
      toggleLoader(false);
    },
    columns: ({ category, setDialog }) => () => {
      const output = get(category, 'attributes', []).map((item) => ({
        name: `${item.id}`,
        title: item.name,
        getCellValue: (row) => {
          const atts = get(row, 'attributes', []);
          const att = find(atts, { attributeId: item.id });
          return get(att, 'value', '');
        },
      }));
      return [
        ...output,
        {
          name: 'delete',
          title: ' ',
          getCellValue: (row) => (
            <div>
              <Button
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  setDialog({ open: true, id: row.id, action: 'product-delete' });
                }}
              >
                Smazat
              </Button>
            </div>
          ),
        },
      ];
    },
    TableRow: ({ redirectTo }) => ({ row, ...restProps }) => (
      <Table.Row
        {...restProps}
        style={{
          cursor: 'pointer',
        }}
        onClick={() => redirectTo(get(row, 'id'))}
      />
    ),
    changeColumnOrder: ({ category, setColumnOrder, toggleLoader }) => async (values) => {
      toggleLoader();
      const order = without(values, 'delete').map((item, i) => ({
        id: item,
        order: i + 1,
      }));
      const resp = await updateCategoryConfig(category.id, order);
      if (get(resp, 'attributesOrder', false)) {
        setColumnOrder(
          without(
            [...resp.attributesOrder.map((item) => `${get(item, 'id', null)}`), 'delete'],
            'null'
          )
        );
      }
      toggleLoader(false);
    },
  })
);

export default enhance(
  ({
    classes,
    TabContainer,
    handleTabChange,
    categories,
    columns,
    products,
    TableRow,
    activeCategory,
    columnOrder,
    changeColumnOrder,
  }) => (
    <div className={classes.root}>
      <Tabs value={activeCategory} onChange={handleTabChange} scrollable scrollButtons="auto">
        {categories.map((item) => (
          <Tab key={item.id} label={item.name} value={item.id} />
        ))}
      </Tabs>
      <TabContainer>
        <Button
          variant="contained"
          color="primary"
          component={(props) => <Link to={`/products/add/category/${activeCategory}`} {...props} />}
          style={{ marginBottom: 20 }}
        >
          Přidat
        </Button>
        <Paper>
          <div className="grid--clickable grid--custom">
            <Grid rows={products || []} columns={columns()}>
              <FilteringState defaultFilters={[]} />
              <SortingState defaultSorting={[{ columnName: 'id', direction: 'asc' }]} />
              <PagingState defaultCurrentPage={0} defaultPageSize={25} />
              <IntegratedFiltering />
              <IntegratedSorting />
              <IntegratedPaging />
              <DragDropProvider />
              <Table rowComponent={TableRow} />
              <TableHeaderRow showSortingControls />
              <TableFilterRow />
              <TableColumnReordering order={columnOrder} onOrderChange={changeColumnOrder} />
              <PagingPanel pageSizes={[10, 25, 50, 0]} />
            </Grid>
          </div>
        </Paper>
      </TabContainer>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/products/index.js